export default {
  inputLabel: {
    id: 'email_collector_input_label',
    defaultMessage: 'E-mail',
  },
  toastSuccessTitle: {
    id: 'email_collector_toast_success_title',
    defaultMessage: 'Perfect!',
  },
  toastSuccessMessage: {
    id: 'email_collector_toast_success_message',
    defaultMessage: 'Thanks for subscribing to our newsletter',
  },
  formMandatoryError: {
    id: 'email_collector_mandatory_field_error',
    defaultMessage: 'This field is mandatory',
  },
  legalLinkText: {
    id: 'email_collector_legal_link_text',
    defaultMessage: 'Read the data protection policy',
  },
  legalTextShort: {
    id: 'email_collector_legal_text_short',
    defaultMessage: 'See offer conditions',
  },
  submitButtonLabel: {
    id: 'email_collector_submit_button_label',
    defaultMessage: 'Sign up',
  },
  toggleLabel: {
    id: 'email_collector_learn_more',
    defaultMessage: 'Learn more',
  },
}
